import React from 'react';
import '../styles/ContentBody.scss';

const ContentBody = ({children}) => <div className="content-body">{children}</div>;

export default ContentBody;
